<div class="row">
    <div class="col-12">

        <div class="card">
    
            <div class="card-header">
                <div class="tools d-flex justify-content-between">
                    <div class="tools-position">
                        <!-- Выпадающий список с доступными действиям -->
                        <ff-actions-menu *ngIf="checkedCheckBox()"
                            [actionListData]="actionsList" [listData]="roles" [ids]="allIds"
                            (changeValue)="getList()" [countSelectedFiles]="countSelectedFiles"
                            (deletedData)="deleteSelected($event)"></ff-actions-menu>
                        <form [formGroup]="form" class="form-group" [ngClass]="{'ml-0': !checkedCheckBox()}">
                            <div class="search input-group">
                                <svg-icon class="serch-icon" src="/assets/images/icons/closed-page-layout/search.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
            
                                <input formControlName="search" class="form-control" type="text" (keydown.delete)="onClear()" placeholder="{{ 'поиск роли' | translate }}" aria-label="Search">

                                <button type="button" class="close clear" aria-label="Close" (click)="onClear()">
                                    <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                </button>
                            </div>
                        </form>

                    </div>
                    <div class="tools-position">
                        <button type="button"
                            class="btn btn-primary btn-sm btn-add" (click)="roleEditRights(null, null)">
                            <!-- <i class="bi bi-plus-circle"></i> -->
                            <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            <span>{{ 'Создать роль' | translate }}</span>
                        </button>

                    </div>



                </div>
            </div>

        </div>

        <div class="card card-inner-roles">
            <!-- <div class="card-header">

                search
                <div class="title"> 
                    {{ 'ORGANIZATION.USER_ORG_ROLES.USERS_ORG_LIST' | translate }} 
                </div>

                tools
                <div class="tools">

                    btn create role
                    <button type="button" class="btn btn-primary btn-sm" (click)="roleEditRights(null, null)">
                        Создать роль
                    </button>

                    btn delete selected
                    <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> Удалить выбранное
                    </button>
                </div>
            </div> -->

            <div class="card-body card-body_table-roles">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="btn-group me-3">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" name="select_all"
                                            id="select_all" [checked]="checkedCheckBox()"
                                            [indeterminate]="checkedButNotAllCheckBox()"
                                            (change)="checkAllCheckBox($event)">
                                        <label class="custom-control-label" for="select_all"></label>
                                    </div>
                                    <!-- <div class="btn-group" ngbDropdown role="group">
                                        <button type="button" class="btn btn-dropdown dropdown-toggle-split" ngbDropdownToggle></button>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <button ngbDropdownItem>
                                                <span (click)="chooseAllFiles()">
                                                    {{ 'PRODUCT.SELECTED_ALL_PRODUCTS' | translate }}
                                                </span>
                                            </button>
                                            <button ngbDropdownItem>
                                                <span (click)="unChooseAllFiles()">
                                                    {{ 'PRODUCT.UNSELECTED_ALL_PRODUCTS' | translate }}
                                                </span>
                                            </button>
                                        </div>
                                    </div> -->
                                </div>
                                <!-- <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_all"
                                        id="select_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_all"></label>
                                </div> -->
                            </th>
                            <th scope="col" class="name derection" (click)="sortData('name')">
                                <div class="th-pos">
                                    <span>{{ 'ORGANIZATION.USER_ORG_ROLES.ROLE_NAME' | translate }} </span>
                                    <div class="derection-arrow">
                                        <i *ngIf="checkDirection('name') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                        <i *ngIf="checkDirection('name') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                        <i *ngIf="checkDirection('name') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" class="creator" (click)="sortData('create_user')">
                                <div class="th-pos">
                                    <span>Создатель</span>
                                    <div class="derection-arrow">
                                        <i *ngIf="checkDirection('create_user') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                        <i *ngIf="checkDirection('create_user') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                        <i *ngIf="checkDirection('create_user') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                    </div>
                                </div> 
                            </th>
                            <!-- <th scope="col" class="status" (click)="sortData('state_id')"> -->
                            <th scope="col" class="status" (click)="sortData('state_id')">
                                <div class="th-pos">
                                    <span>Статус</span> 
                                    <div class="derection-arrow">
                                        <i *ngIf="checkDirection('state_id') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                        <i *ngIf="checkDirection('state_id') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                        <i *ngIf="checkDirection('state_id') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" class="createDate" (click)="sortData('create_date')">
                                <div class="th-pos">
                                    <span>Создан</span> 
                                    <div class="derection-arrow">
                                        <i *ngIf="checkDirection('create_date') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                        <i *ngIf="checkDirection('create_date') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                        <i *ngIf="checkDirection('create_date') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                    </div>
                                </div>
                            </th>
                            <th scope="col" class="lastEdit" (click)="sortData('change_date')">
                                <div class="th-pos">
                                    <span>Последнее изменение</span>
                                    <div class="derection-arrow">
                                        <i *ngIf="checkDirection('change_date') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                        <i *ngIf="checkDirection('change_date') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                        <i *ngIf="checkDirection('change_date') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                    </div> 
                                </div>
                            </th>
                            <th scope="col" class="action"></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="roles && roles.length > 0">
                        <tr *ngFor="let role of roles; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_{{ i }}"
                                        id="select_{{ i }}" [checked]="role.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name"> {{ role.name }} </td>
                            <td class="creator"> {{ role.create_user}} </td>
                            <td class="status">
                                <div class="state" [ngClass]="role.state_id.toLowerCase()">
                                    {{ getRoleStatus(role.state_id) }}
                                </div>
                            </td>
                            <td class="createDate"> {{ role.create_date | date: 'dd.MM.yyyy HH:mm' }} </td>
                            <td class="lastEdit"> {{ role.change_date | date: 'dd.MM.yyyy HH:mm' }} </td>
                            <td class="action">
                                <div class="action-btn">
                                    <!-- btn unlock role -->
                                    <button type="button" class="btn btn-none role-unlock" *ngIf="!role.blocked" (click)="roleLockAndUnlockControl(role.urole.id, true)" placement="left" tooltipClass="clue-name" ngbTooltip="Заблокировать роль">
                                        <svg-icon class="" src="/assets/images/icons/unlock.svg" [stretch]="true" [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                    </button>
    
                                    <!-- btn block role -->
                                    <button type="button" class="btn btn-none role-lock" *ngIf="role.blocked" (click)="roleLockAndUnlockControl(role.urole.id, false)" placement="left"  tooltipClass="clue-name" ngbTooltip="Разблокировать роль">
                                        <svg-icon class="" src="/assets/images/icons/lock.svg" [stretch]="true"[svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                    </button>
    
                                    <section class="action-btn_list">
        
                                        <ng-template class="btn-list" #popContent>
    
                                            <div class="btn-list_item"
                                                (click)="onEdit(role.urole.id)">
                                                <span>{{ 'Редактировать' | translate }}</span>
                                            </div>
    
                                            <div class="list-item_delete"
                                                (click)="deleteOneRole(role.urole.id)">
                                                <span>{{ 'Удалить' | translate }}</span>
                                            </div>
    
                                        </ng-template>
    
                                        <button type="button" placement="left" [ngbPopover]="popContent"
                                            [autoClose]="true" triggers="manual" #p="ngbPopover"
                                            class="btn btn-none action-btn_active btn-sm"
                                            popoverClass="my-custom-class"
                                            (click)="openWindowWithButton(p)"
                                            ngbTooltip="Действия">
                                            <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':18, 'height.px':18}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                            <!-- <i class="bi bi-three-dots-vertical"></i> -->
                                        </button>
                                    </section>
    
                                    <!-- btn edit role
                                    <button type="button" class="btn btn-light" (click)="onEdit(role.urole.id)" placement="top" ngbTooltip="Редактировать роль">
                                        <i class="bi bi-pencil-square"></i> 
                                    </button>
    
                                    btn delete role
                                    <button type="button" class="btn btn-light" (click)="deleteOneRole(role.urole.id)" placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                        <i class="bi bi bi-trash"></i> 
                                    </button> -->
                                </div>

                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!roles || roles.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="12">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="12">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div> -->

        </div>
        <div class="pagination-component-roles">
            <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
        </div>

    </div>
</div>